import IVendorConfig from 'src/environments/Ivendor-config';

export function traferaMapper(config: IVendorConfig) {
    config.chromebaseFilterLabel = '';
    config.chromeboxFilterLabel = '';
    config.startTitle = "Find your perfect Chromebook device";
    config.startSubtitle = "Make a few selections and we'll show you the best Chromebook for your needs.";
    config.brandsOptionsToDisplay = [
        "Lenovo", "Acer", "ASUS", "Dell", "HP"
      ];
}
